// src/components/UI/components/DropdownMenu/DropdownMenuLabel.tsx

import { Label } from '@radix-ui/react-dropdown-menu';
import { forwardRef } from 'react';
import { cx } from '../../lib/utils';

const DropdownMenuLabel = forwardRef<
  React.ElementRef<typeof Label>,
  React.ComponentPropsWithoutRef<typeof Label>
>(({ className, ...props }, forwardedRef) => (
  <Label
    ref={forwardedRef}
    className={cx(
      // base
      'px-2 py-2 text-xs font-medium tracking-wide',
      // text color
      'text-gray-500 dark:text-gray-500',
      className,
    )}
    {...props}
  />
));
DropdownMenuLabel.displayName = 'DropdownMenuLabel';

export { DropdownMenuLabel };
